export const msalConfig = {
    auth: {
      clientId: process.env.REACT_APP_MS_ONE_DRIVE, 
      authority: "https://login.microsoftonline.com/common",
      redirectUri: process.env.REACT_APP_URL + "/auth/login",
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
  };
  
export const loginRequest = {
    scopes: ["openid", "profile", "email", "User.Read"],
};